import { QueryHookOptions } from '@apollo/client';

import { useKioskDefaultScreenQuery, KioskDefaultScreenQuery } from '@occc/graphql';

type GetDefaultScreenProps = {
  id: string;
  baseOptions?: Omit<QueryHookOptions<KioskDefaultScreenQuery, { id: string }>, 'variables'>;
};

export const useGetDefaultScreen = ({ id, baseOptions }: GetDefaultScreenProps) => {
  const response = useKioskDefaultScreenQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    ...baseOptions,
    variables: { id },
  });

  return {
    ...response,
    defaultScreen: response.data?.kioskDefaultScreen,
  };
};
